import { Component, ElementRef, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { pointer, select } from 'd3-selection';
import { CaliperFactoryService } from '../../utils/caliper-factory.service';
import { TraceViewModel } from '../../view-models/trace-viewmodel';
import { CaliperViewModel } from '../../view-models/caliper-viewmodel';
import { CaliperMessage } from '../../view-models/ecgstate';
import { ICaliperViewModel, ITraceViewModel } from '../../models/interfaces';
import { CaliperMessageService } from 'projects/ecg-viewer-html5/src/store/caliper-message.service';
import { NgForOf } from '@angular/common';
import { StepComponent } from './step/step.component';
import { CaliperComponent } from '../caliper/caliper.component';

@Component({
    selector: '[ecg-trace]',
    templateUrl: './trace.component.html',
    styleUrls: ['./trace.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [NgForOf, StepComponent, CaliperComponent],
})
export class TraceComponent implements OnDestroy, OnInit {
    // data members
    @Input()
    trace!: TraceViewModel;

    constructor(
        private elementRef: ElementRef,
        private caliperFactoryService: CaliperFactoryService,
        private caliperMessageService: CaliperMessageService,
    ) {}

    // public functions
    ngOnInit() {
        let element: any = select(this.elementRef.nativeElement).select('#bandOptions').node();
        select(this.elementRef.nativeElement)
            .select('#bandOptions')
            .on('click', (event) => {
                let coordinates = { x: pointer(event, element)[0], y: pointer(event, element)[1] };
                this.onBandOptionsClicked(coordinates);
            });
    }

    ngOnDestroy() {
        select(this.elementRef.nativeElement).select('#bandOptions').on('click', null);
    }

    onRemoveCaliper(caliper: CaliperViewModel) {
        this.caliperMessageService.sendMessage(new CaliperMessage(this.trace, caliper), 'CALIPER_REMOVE');
    }

    onMeasuresChange(caliper: CaliperViewModel) {
        this.caliperMessageService.sendMessage(new CaliperMessage(this.trace, caliper), 'CALIPER_MODIFY');
    }

    // private functions

    private onBandOptionsClicked = (coordinates: { x: number; y: number }) => {
        if (!this.trace && !coordinates) return;
        const caliper = this.createCaliper(this.trace, coordinates);
        if (!!caliper) {
            this.caliperMessageService.sendMessage(new CaliperMessage(this.trace, caliper), 'CALIPER_ADD');
        }
    };

    private createCaliper(trace: ITraceViewModel, coordinates: { x: number; y: number }): ICaliperViewModel | null {
        const caliper = this.caliperFactoryService.create(trace, coordinates);
        if (!caliper) return null;
        caliper.opacity = 1;
        caliper.setPositionX(coordinates.x, 15);
        caliper.window.opacity = 0;

        return caliper;
    }
}
